import _extends from"@babel/runtime/helpers/extends";var _this=this,_jsxFileName="/home/runner/work/prd-nxg-smartapps/prd-nxg-smartapps/packages/app@smartott/src/bluu/pages/_app.js";import React from'react';
import'@adyen/adyen-web/dist/adyen.css';
import'react-loading-skeleton/dist/skeleton.css';

import App from"../app";

var WebApp=function WebApp(props){return React.createElement(App,_extends({},props,{__self:_this,__source:{fileName:_jsxFileName,lineNumber:7,columnNumber:27}}));};

export default WebApp;